import React, { ReactNode, useEffect, useRef } from 'react';
import './MenuScroll.scss';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';

interface MenuScrollProps {
    children: ReactNode;
    parentClass?: string;
    elementClass?: string;
}

const MenuScroll = ({ children, parentClass, elementClass }: MenuScrollProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const parentRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const el = ref.current;
        const parentEl = parentRef.current;
        const updateIndicators = () => {
            if (el === null || parentEl === null) return;
            const { scrollTop, scrollHeight, clientHeight } = el;
            parentEl.classList.toggle('show-top', scrollTop > 0);
            parentEl.classList.toggle('show-bottom', scrollTop + clientHeight < (scrollHeight - 5));
        };

        updateIndicators();
        el?.addEventListener('scroll', updateIndicators);

        return () => el?.removeEventListener('scroll', updateIndicators);
    }, []);

    return (
        <div ref={parentRef} className={['scroll-menu-container', parentClass].filter(Boolean).join(' ')}>
            <FaCaretUp className='scroll-up-indicator' />
            <div
                ref={ref}
                className={['scroll-menu', elementClass].filter(Boolean).join(' ')}
            >
                {children}
            </div>
            <FaCaretDown className='scroll-down-indicator' />
        </div>
    );
};

export default MenuScroll;
